<template>
  <div id="app">
    <div id="wrapper">
      <div id="main">
        <div>
          <navbar></navbar>
        </div>
        <b-container>
          <router-view />
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue';

export default {
  components: {
    Navbar,
  },
  created() {
    // clears the url of tokens
    if (
      window.location.href.includes("id_token") ||
      window.location.href.includes("access_token")
    ) {
      this.$router.push({ name: "Home" });
    }
  },
};
</script>

<style lang="scss">
@import "custom.scss";
</style>